import React, { useState } from 'react';
import axios from 'axios';
import { BACKEND_URL, APP_VERSION, ENABLE_LOG } from '../config';

const LoginDemo = ({ onLogin }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleRealLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    // Usamos la URL desde config.js (Soporta Runtime)
    const backendUrl = BACKEND_URL;
    
    if (!backendUrl) {
      setLoading(false);
      setError('Config Error: BACKEND_URL missing (Check Runtime Config).');
      return;
    }
    
    const cleanUrl = backendUrl.trim().replace(/\/$/, '');

    try {
      const response = await axios.post(`${cleanUrl}/api/auth/login`, {
        email: email.trim(),
        password: password
      });

      if (response.data.token) {
        onLogin({ 
          name: response.data.user.nombre,
          email: response.data.user.email, 
          role: response.data.user.rol,
          token: response.data.token
        });
      }
    } catch (err) {
      if (ENABLE_LOG) console.error('Auth Error:', err.response?.data || err.message);
      setError(err.response?.data?.error || 'Credenciales inválidas.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="d-flex justify-content-center align-items-center vh-100 bg-light">
      <div className="card shadow p-4" style={{minWidth: '350px', borderRadius: '15px'}}>
        <h2 className="text-center mb-4 text-primary fw-bold">Icarosoft Legal</h2>
        <p className="text-center text-muted small mb-4">Módulo Administrativo</p>
        
        <form onSubmit={handleRealLogin}>
          <div className="mb-3">
            <label className="form-label text-muted small">Usuario / Email</label>
            <input 
              type="text" 
              className="form-control" 
              placeholder="Ingrese su usuario"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <div className="mb-4">
            <label className="form-label text-muted small">Contraseña</label>
            <input 
              type="password" 
              className="form-control" 
              placeholder="********"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          
          {error && <div className="alert alert-danger small py-2">{error}</div>}

          <button 
            type="submit" 
            className="btn btn-primary w-100 py-3 fw-bold"
            disabled={loading}
          >
            {loading ? 'VALIDANDO...' : 'INICIAR SESIÓN'}
          </button>
        </form>
        <div className="mt-4 text-center border-top pt-3 text-muted small">
          Versión {APP_VERSION} | icarosoft.com
        </div>
      </div>
    </div>
  );
};

export default LoginDemo;
